import React from 'react';

import IconType from '../../../types/Icon';

const RemoveIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.7712 3.28686L8 7.0581L4.22876 3.28686L3.28595 4.22967L7.05719 8.00091L3.28595 11.7721L4.22876 12.715L8 8.94372L11.7712 12.715L12.714 11.7721L8.94281 8.00091L12.714 4.22967L11.7712 3.28686Z"
				fill={color}
			/>
		</svg>
	);
};

export default RemoveIcon;
